module.exports = __webpack_public_path__ + "218a0148499cc5fd43876c548da9d75b.svg";